import { request } from 'umi';

export async function getClient(client: string, isDemo: number) {
  return request<API.Client>('/api/clients', {
    method: 'GET',
    params: {
      client,
      isDemo,
    },
  });
}
